import { Routes } from '@angular/router';
import { AUTH_ROUTES } from '../routes/auth.routes';
import { ADMIN_ROUTES } from '../routes/admin.routes';
import { ERROR_ROUTES } from '../routes/error.routes';
import { LandingLayout } from '../layouts/landing-layout/landing-layout';

export const routes: Routes = [
    {
        path: '',
        component: LandingLayout,
        children: [
            {
                path: '',
                loadComponent: () => import('../features/landing/landing').then(m => m.Landing)
            }
        ]
    },
    {
        path: 'setup',
        loadComponent: () => import('../features/setup/setup').then(m => m.Setup)
    },
    {
        path: 'verify-email',
        loadComponent: () => import('../features/verify-email/verify-email').then(m => m.VerifyEmail)
    },
    {
        path: 'print/receipt/:id',
        loadComponent: () => import('../features/billing/thermal-receipt/thermal-receipt').then(m => m.ThermalReceipt)
    },
    {
        path: 'print/ledger/:patientId',
        loadComponent: () => import('../features/billing/ledger-receipt/ledger-receipt').then(m => m.LedgerReceipt)
    },
    ...ADMIN_ROUTES,
    ...AUTH_ROUTES,
    ...ERROR_ROUTES,
];
